// Calendar-day helpers on 'YYYY-MM-DD' strings. Arithmetic runs in UTC so daylight-saving
// changes can never skip or repeat a day. Weeks start on Monday (Swift Calendar.chefiPlanner).
import type { Day, Weekday } from '../types';

export const WEEKDAYS: Weekday[] = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

function toUTC(day: Day): Date {
  const [y, m, d] = day.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d));
}

export function fromUTC(date: Date): Day {
  return date.toISOString().slice(0, 10);
}

/** Today in the user's local time zone. */
export function localDay(now: Date = new Date()): Day {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function addDays(day: Day, n: number): Day {
  const t = toUTC(day);
  t.setUTCDate(t.getUTCDate() + n);
  return fromUTC(t);
}

export function daysBetween(from: Day, to: Day): number {
  return Math.round((toUTC(to).getTime() - toUTC(from).getTime()) / 86_400_000);
}

export function weekdayOf(day: Day): Weekday {
  return WEEKDAYS[toUTC(day).getUTCDay()];
}

/** Monday of the week containing `day`. */
export function startOfWeek(day: Day): Day {
  const dow = toUTC(day).getUTCDay(); // 0 = Sunday
  return addDays(day, -((dow + 6) % 7));
}
